import { makeResource } from '@codium/codium-vue'

export const { storeModule, helperComputed, helperMethods, stateMapper } = makeResource('settings/integrations/screens', {
  namespaced: true,
  storeModule: {

    actions: {
    },
  },
  resource () {
    return {}
  }
})
